import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { Select } from "@/components/elements/Select";
import { UserRoleHelperContent } from "@/features/customer-user/components/UserRoleHelperContent";
import { USER_ROLE_OPTIONS } from "@/features/customer-user/constant/options";
import { TCustomerUserForm } from "@/features/customer-user/types/customerUserForm";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Control } from "react-hook-form";

type TProps = {
  control: Control<TCustomerUserForm>;
  isEdit?: boolean;
  currentEmail?: string;
};

export const CustomerUserBasicInfoFields: FC<TProps> = ({ control, isEdit, currentEmail }) => (
  <InnerBox title="基本情報" padding="24px">
    <Stack gap="24px">
      <Stack direction="row" gap="48px" flexWrap="wrap">
        <Stack flex={1} minWidth={0}>
          <FormField control={control} name="fullName">
            <Input />
          </FormField>
        </Stack>
        <Stack flex={1} minWidth={0}>
          <FormField control={control} name="role" helper="role" helperContent={<UserRoleHelperContent />}>
            <Select options={USER_ROLE_OPTIONS} clearable={false} />
          </FormField>
        </Stack>
      </Stack>
      <Stack direction="row" gap="48px" flexWrap="wrap">
        {isEdit ? (
          <>
            <Stack flex={1} minWidth={0}>
              <FormField label="現在のメールアドレス">
                <Input readonly value={currentEmail ?? ""} />
              </FormField>
            </Stack>
            <Stack flex={1} minWidth={0}>
              <FormField control={control} name="newEmail">
                <Input />
              </FormField>
            </Stack>
          </>
        ) : (
          <>
            <Stack flex={1} minWidth={0}>
              <FormField control={control} name="email">
                <Input />
              </FormField>
            </Stack>
            <Stack flex={1} minWidth={0} />
          </>
        )}
      </Stack>
    </Stack>
  </InnerBox>
);
